import { render } from "./WarehouseWriteOffOperation.vue?vue&type=template&id=3518825d"
import script from "./WarehouseWriteOffOperation.vue?vue&type=script&lang=js"
export * from "./WarehouseWriteOffOperation.vue?vue&type=script&lang=js"

import exportComponent from "/Volumes/Whisper/Development/projects/sid/ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__